import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M12.001 2C6.477 2 2 6.477 2 11.999C2 17.523 6.477 22 12.001 22C17.522 22 22 17.523 22 11.999C22 6.477 17.522 2 12.001 2ZM12.934 5.61C13.909 5.61 14.195 6.176 14.195 6.822C14.195 7.629 13.549 8.376 12.446 8.376C11.523 8.376 11.084 7.912 11.111 7.145C11.111 6.499 11.652 5.61 12.934 5.61V5.61ZM10.436 17.989C9.769 17.989 9.283 17.584 9.749 15.808L10.513 12.657C10.645 12.153 10.667 11.951 10.513 11.951C10.314 11.951 9.448 12.299 8.938 12.643L8.606 12.098C10.226 10.745 12.088 9.951 12.885 9.951C13.552 9.951 13.662 10.738 13.33 11.951L12.455 15.263C12.3 15.848 12.366 16.05 12.522 16.05C12.722 16.05 13.376 15.808 14.02 15.301L14.397 15.807C12.819 17.383 11.102 17.989 10.436 17.989Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'InfoFill');

export default Icon;
